import produce from 'immer';
import {
    SET_BREADCRUMB,
    SET_BREADCRUMB_TITLE,
    SET_BREADCRUMB_ITEMS,
    SET_CURRENT_ORDER_ID,
    RECEIVE_CUSTOMER_ORDERS,
    RECEIVE_CUSTOMER_ORDERS_ERROR,
    DASHBOARD_SET_HEADER_ELEMENT,
    SET_STORE_CONFIG,
    RECEIVE_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS,
    FETCH_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS_ERROR,
    RECEIVE_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID,
    FETCH_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID_ERROR,
    UPDATE_CUSTOMER_BOOZTPAY_DETAILED_INVOICE_POSTPONED_STATUS_BY_ID,
    FETCH_BOOZTPAY_ACCOUNT_SUCCESS,
    RECEIVE_ORDERS_COUNT,
    RECEIVE_MENU,
    RECEIVE_BOOZTPAY_INVOICES,
    REMOVE_INVOICE_DETAILS,
    RECEIVE_LOCALIZATION_OPTIONS,
    SET_CURRENT_MENU_ITEM,
    SET_CUSTOMER_ORDERS_LIST,
    SET_GIFT_CARDS,
    SET_GIFT_CARDS_ERROR,
    ADD_GIFT_CARD,
    SET_VOUCHERS,
    SET_VOUCHERS_ERROR,
    SET_TRANSACTIONS,
    SET_TRANSACTIONS_ERROR,
    UPDATE_VOUCHER,
    SET_RETURNS,
    SET_RETURNS_ERROR,
    LOAD_MORE_RETURNS,
    SET_RETURNS_LABELS,
    SET_RETURNS_LABELS_ERROR
} from '../constants';
import { list } from '../constants/orderContexts';

const initialState = {
    breadcrumb: {
        title: '',
        subtitle: '',
        subtitleIcon: null,
        items: [],
        titleImage: null
    },
    currentOrderId: null,
    currentMenuItem: null,
    customer: null,
    isFetchedOrdersCount: false,
    orders: {
        list: { data: undefined, total: 0, offset: null },
        returns: { data: undefined, total: 0, offset: null }
    },
    booztpay: {
        invoices: null,
        account: null,
        accountOrders: { orders: [], error: null, isLoaded: false },
        detailedInvoices: {}
    },
    headerElement: null,
    storeConfig: {},
    menu: null,
    localizationOptions: {
        countries: [],
        phonePrefixes: {}
    },
    giftCards: {
        data: null,
        error: null
    },
    vouchers: {
        data: null,
        error: null
    },
    transactions: {
        data: null,
        error: null
    },
    returns: {
        data: null,
        error: null
    },
    returnsLabels: {
        data: null,
        error: null
    }
};

// eslint-disable-next-line import/prefer-default-export
export const dashboard = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_BREADCRUMB:
            state.breadcrumb = payload;
            break;

        case SET_BREADCRUMB_TITLE:
            state.breadcrumb.title = payload;
            break;

        case SET_BREADCRUMB_ITEMS:
            state.breadcrumb.items = payload;
            break;

        case SET_CURRENT_ORDER_ID:
            state.currentOrderId = payload;
            break;

        case RECEIVE_CUSTOMER_ORDERS: {
            const { context, offset, orders } = payload;

            if (!state.orders[context].data) {
                state.orders[context].data = [];
            }

            state.orders[context].data = state.orders[context].data.concat(orders.data);

            let total;

            if (context === 'returns') {
                total = orders.pagination.count;
            } else {
                total = orders.total;
            }

            state.orders[context].total = total;
            state.orders[context].offset = offset;

            break;
        }

        case RECEIVE_CUSTOMER_ORDERS_ERROR: {
            const { context } = payload;

            state.orders[context].data = null;

            break;
        }

        case RECEIVE_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS: {
            state.booztpay.accountOrders = { orders: payload, isLoaded: true, error: null };
            break;
        }

        case FETCH_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS_ERROR: {
            state.booztpay.accountOrders = { orders: [], error: payload };
            break;
        }

        case RECEIVE_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID: {
            const { entityId, data } = payload;

            state.booztpay.detailedInvoices[entityId] = { invoice: data, error: null };

            break;
        }

        case FETCH_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID_ERROR: {
            const { invoiceId, error } = payload;
            state.booztpay.detailedInvoices[invoiceId] = { invoice: null, error };
            break;
        }

        case UPDATE_CUSTOMER_BOOZTPAY_DETAILED_INVOICE_POSTPONED_STATUS_BY_ID: {
            const { invoiceId, postponed } = payload;

            const invoice = produce(
                state.booztpay.detailedInvoices[invoiceId].invoice,
                (draftInvoice) => { draftInvoice.postponed = postponed; }
            );

            state.booztpay.detailedInvoices[invoiceId].invoice = invoice;
            break;
        }

        case RECEIVE_ORDERS_COUNT: {
            state.orders[list].total = payload;
            state.isFetchedOrdersCount = true;
            break;
        }

        case REMOVE_INVOICE_DETAILS: {
            state.booztpay.detailedInvoices[payload] = null;
            break;
        }

        case DASHBOARD_SET_HEADER_ELEMENT: {
            state.headerElement = payload;
            break;
        }

        case SET_STORE_CONFIG: {
            state.storeConfig = payload;
            break;
        }

        case FETCH_BOOZTPAY_ACCOUNT_SUCCESS: {
            state.booztpay.account = payload;
            break;
        }

        case RECEIVE_MENU: {
            state.menu = payload;
            break;
        }

        case RECEIVE_BOOZTPAY_INVOICES: {
            state.booztpay.invoices = payload;
            break;
        }

        case RECEIVE_LOCALIZATION_OPTIONS: {
            state.localizationOptions = payload;
            break;
        }

        case SET_CURRENT_MENU_ITEM: {
            state.currentMenuItem = payload;
            break;
        }

        case SET_CUSTOMER_ORDERS_LIST: {
            const { offset, orders } = payload;
            const { data, total } = orders;

            state.orders.list.data = data;
            state.orders.list.total = total;
            state.orders.list.offset = offset;
            break;
        }

        case SET_GIFT_CARDS: {
            state.giftCards = {
                data: payload,
                error: null
            };

            break;
        }

        case SET_GIFT_CARDS_ERROR: {
            state.giftCards.error = payload;
            break;
        }

        case ADD_GIFT_CARD: {
            state.giftCards.data.push(payload);
            break;
        }

        case SET_VOUCHERS: {
            state.vouchers = {
                data: payload,
                error: null
            };

            break;
        }

        case SET_VOUCHERS_ERROR: {
            state.vouchers.error = payload;
            break;
        }

        case SET_TRANSACTIONS: {
            state.transactions = {
                data: payload,
                error: null
            };

            break;
        }

        case SET_TRANSACTIONS_ERROR: {
            state.transactions.error = payload;
            break;
        }

        case UPDATE_VOUCHER: {
            state.vouchers.data = produce(
                state.vouchers.data,
                (draftVouchersData) => {
                    const index = draftVouchersData.vouchers.findIndex(voucher => voucher.id === payload.id);
                    draftVouchersData.vouchers.splice(index, 1, payload);
                }
            );

            break;
        }

        case SET_RETURNS: {
            state.returns.error = null;
            state.returns.data = payload;

            break;
        }

        case LOAD_MORE_RETURNS: {
            state.returns.error = null;
            state.returns.data.pagination = payload.pagination;
            state.returns.data.returns = [...state.returns.data.returns, ...payload.returns];

            break;
        }

        case SET_RETURNS_ERROR: {
            state.returns.error = payload;
            break;
        }

        case SET_RETURNS_LABELS: {
            state.returnsLabels.error = null;
            state.returnsLabels.data = payload;

            break;
        }

        case SET_RETURNS_LABELS_ERROR: {
            state.returnsLabels.error = payload;
            break;
        }

        // skip default
    }
}, initialState);
